// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2NrpN","logo__list":"Logo_logo__list__1KzIx","logo__list__item":"Logo_logo__list__item__ePOcR"};